import { updateFirebaseAuditLog } from 'lib/firebase';
import { StoredUser } from 'store/features/authentication';

/** Update the audit log firebase entry at the audit/${target} firebase table. */
export const updateAuditLog = async (
    supplierId: string,
    user: StoredUser,
    target: string,
    oldVal: any,
    newVal: any
): Promise<void> => {
    const now = new Date();

    const payload = {
        supplierId,
        email: user.email,
        uid: user.uid,
        time: now.getTime(),
        time_iso: now.toISOString(),
        oldVal,
        newVal,
    };

    return updateFirebaseAuditLog(target, payload);
};
